<template>
    <slot v-bind="{ ...state, setDialog, handleClose }" />
</template>

<script setup>
import { onBeforeUnmount, onMounted, reactive } from 'vue';

const state = reactive({
    performances: [],
});

let dialog = null;

const setDialog = element => {
    dialog = element;
}

const handleShowEventFavoriteDialog = event => {
    state.performances = event.detail.performances;
    dialog.showModal();
}

const handleClose = () => {
    dialog.close();
}

onMounted(() => {
    window.addEventListener('showEventFavoriteDialog', handleShowEventFavoriteDialog);
});

onBeforeUnmount(() => {
    window.removeEventListener('showEventFavoriteDialog', handleShowEventFavoriteDialog);
});
</script>
